import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
const useToken = () => {
    const [token, setToken] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const storedToken = JSON.parse(localStorage.getItem('auth'));
        if (storedToken?.user.username) {
            try {
                setToken(storedToken);
            } catch (error) {
                localStorage.removeItem('auth');
                setToken(null);
            }
        } else {
            navigate('/auth');
            setToken(null);
        }
    }, []);

    return { token };
}

export default useToken;